"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAnalyticsTracking = void 0;
const react_1 = __importDefault(require("react"));
const contexts_1 = require("../contexts");
/**
 * Will track an event in our analytics tool, typically [**Amplitude**](https://analytics.amplitude.com/mulesoft/workspace).
 * Notice that final implementation of analytics tracking exists in [**exchange-ui**](https://github.com/mulesoft/exchange-ui) project. You will not be able to test analytics in any other environment other than **exchange-ui**.
 *
 * @example
 *
 * ```ts
 * import { useAnalyticsTracking } from '@mulesoft/exchange-react-hooks';
 *
 * const MyComponent = ({ ...props }) => {
 *   const trackEvent = useAnalyticsTracking();
 *
 *   trackEvent('Event was executed', { foo: 'bar', baz: 123 });
 * };
 * ```
 * @returns A function to track an event in Analytics
 */
function useAnalyticsTracking() {
    const { trackEvent } = react_1.default.useContext(contexts_1.AnalyticsContext);
    return trackEvent;
}
exports.useAnalyticsTracking = useAnalyticsTracking;
